import axios from "axios";
import moment from "moment";

export const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const regexSenha = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[*!\\!@#$%&/+\-=]).{8,}$/;
export const regexMinimo8Caracteres = /^.{8,}$/;
export const regexAoMenos1LetraMinuscula = /^(?=.*[a-z]).+$/;
export const regexAoMenos1LetraMaiuscula = /^(?=.*[A-Z]).+$/;
export const regexAoMenos1Numero = /^(?=.*\d).+$/;
export const regexAoMenos1CaracterEspecial = /^(?=.*[*!\\!@#$%&/+\-=]).+$/;

export const createFormikValidation = (formMap, values) => {
    const errors = {};

    for (let [key, value] of formMap) {
        if (!values[key] && values[key] !== 0) {
            if (value) {
                errors[key] = "O campo " + value + " é obrigatório.";
            } else {
                errors[key] = "O campo é obrigatório.";
            }
        } else if (key.includes("email") && !regexEmail.test(values[key])) {
            errors[key] = "Você precisa informar um e-mail válido.";
        } else if ((key.includes("senha") || key.includes("password")) && !regexSenha.test(values[key])) {
            errors[key] = "A senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas, números e caracteres especiais (*!@#$%&/+-=).";
        } else if (key.includes("cep") && values[key].length < 9) {
            errors[key] = "Utilize no mínimo 8 caracteres.";
        } else if (key.includes("cpf") && key.includes("cnpj")) {
            if (values[key].length > 14 && !validaCnpj(values[key])) {
                errors[key] = "O CNPJ informado é inválido.";
            } else if (values[key].length <= 14 && !validaCpf(values[key])) {
                errors[key] = "O CPF informado é inválido.";
            }
        } else if (key.includes("cpf") && !validaCpf(values[key])) {
            errors[key] = "O CPF informado é inválido.";
        } else if (key.includes("cnpj") && !validaCnpj(values[key])) {
            errors[key] = "O CNPJ informado é inválido.";
        } else if (key.includes("telefone") && values[key].length < 14) {
            errors[key] = "Utilize no mínimo 10 dígitos.";
        } else if (key.includes("data_nascimento") && moment(values[key]).isAfter(moment())) {
            errors[key] = "A data de nascimento não pode ser uma data futura.";
        }
    }

    return errors;
};

export const shallowEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
};

export const formatHourInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1:$2");

    input.target.value = value;

    return input;
};

export const formatCNPJInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1/$2");
    value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatCPFInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatCPForCNPJInput = (input) => {
    if (input?.target?.value?.replace(/\D/g, "")?.length > 11) {
        return formatCNPJInput(input);
    } else {
        return formatCPFInput(input);
    }
};

export const formatDataInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");

    input.target.value = value;

    return input;
};

export const formatTelefoneInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.substring(0, 11);
    value = value.replace(/(\d{0})(\d)/, "$1($2");
    value = value.replace(/(\d{2})(\d)/, "$1) $2");
    value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatCepInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{5})(\d)/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatBRLInput = (input) => {
    input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, "")) / 10 ** 2;

    input.target.value = formatBRL(input.target.value);

    return input;
};

export const formatDecimal = (value, casasDecimais = 0) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: casasDecimais,
        maximumFractionDigits: casasDecimais,
    });

    value = formatter.format(value);

    return value;
};

export const formatBRL = (value) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
    });

    const cleanValue = String(value).replace(/[^\d.-]/g, "");

    value = formatter.format(cleanValue);

    return value;
};

export const formatIntegerInput = (input) => {
    if (input.target.value === "") {
        input.target.value = "";
        return input;
    }

    input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ""));
    return input;
};

export const buscaCep = (input, setFieldValue, nomeEndereco, nomeBairro, nomeCidade, nomeUf, onLoading) => {
    if (input.target.value.length > 8) {
        var cep = input.target.value.replace(/[^0-9]/, "");

        const instance = axios.create();

        if (onLoading) {
            onLoading(true);
        }

        instance
            .get(`https://viacep.com.br/ws/${cep}/json/`, {})
            .then((res) => {
                if (res.data.erro) {
                    setFieldValue(nomeEndereco, "");
                    setFieldValue(nomeBairro, "");
                    setFieldValue(nomeCidade, "");
                    setFieldValue(nomeUf, "");
                } else {
                    setFieldValue(nomeEndereco, res.data.logradouro ?? "");
                    setFieldValue(nomeBairro, res.data.bairro ?? "");
                    setFieldValue(nomeCidade, res.data.localidade ?? "");
                    setFieldValue(nomeUf, res.data.uf ?? "");
                }
            })
            .catch((err) => {})
            .finally(() => {
                if (onLoading) {
                    onLoading(false);
                }
            });
    }

    return formatCepInput(input);
};

export const fetchCitiesByUF = async (uf, onLoading, onData) => {
    if (uf) {
        const instance = axios.create();

        if (onLoading) {
            onLoading(true);
        }

        await instance
            .get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`, {})
            .then((res) => {
                if (res.data?.length) {
                    onData(res.data);
                }
            })
            .catch(() => {
                onData([]);
            })
            .finally(() => {
                if (onLoading) {
                    onLoading(false);
                }
            });
    } else {
        onData([]);
    }
};

export const limparMoeda = (valor) => {
    valor = valor.replace("R$", "");
    valor = valor.replaceAll(".", "");
    valor = valor.replace(",", ".");
    valor = valor.replace("/^p{Z}+|p{Z}+$/u", "");
    valor = valor.trim();

    return valor;
};

export const listaUfs = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"];

export const listaSimNao = [
    { value: 1, label: "Sim" },
    { value: 0, label: "Não" },
];

export const displayValueCurrency = (value) => {
    return value ? `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 2 }).replace(".", ",")}` : "Não disponível";
};

export const displayValueFixed = (value, casas) => {
    return value ? value.toFixed(casas) : "Não disponível";
};

export const displayValuePercent = (value) => {
    return value ? `${value.toLocaleString("pt-BR", { minimumFractionDigits: 2 })} %` : "Não disponível";
};

/* eslint-disable */
export const validaCpf = (cpf) => {
    var add = 0;
    var rev = 0;

    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf == "") return false;

    if (cpf.length != 11) return false;

    if (/^(.)\1*$/.test(cpf)) return false;

    for (var i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i);
    }

    rev = 11 - (add % 11);

    if (rev == 10 || rev == 11) {
        rev = 0;
    }
    if (rev != parseInt(cpf.charAt(9))) {
        return false;
    }

    add = 0;

    for (var j = 0; j < 10; j++) {
        add += parseInt(cpf.charAt(j)) * (11 - j);
    }

    rev = 11 - (add % 11);

    if (rev == 10 || rev == 11) {
        rev = 0;
    }

    if (rev != parseInt(cpf.charAt(10))) {
        return false;
    }

    return true;
};
/* eslint-enable */

export const validaCnpj = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (cnpj.length !== 14) {
        return false;
    }

    if (/^(\d)\1+$/.test(cnpj)) {
        return false;
    }

    let add = 0;
    let rev = 0;
    let pos = 5;

    for (let i = 0; i < 12; i++) {
        add += parseInt(cnpj.charAt(i)) * pos;
        pos = pos === 2 ? 9 : pos - 1;
    }

    rev = add % 11 < 2 ? 0 : 11 - (add % 11);

    if (rev !== parseInt(cnpj.charAt(12))) {
        return false;
    }

    add = 0;
    pos = 6;

    for (let i = 0; i < 13; i++) {
        add += parseInt(cnpj.charAt(i)) * pos;
        pos = pos === 2 ? 9 : pos - 1;
    }

    rev = add % 11 < 2 ? 0 : 11 - (add % 11);

    if (rev !== parseInt(cnpj.charAt(13))) {
        return false;
    }

    return true;
};

export const formatPercentageInput = (input) => {
    if (input.target.value == "") input.target.value = 0;
    input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ""));
    if (input.target.value == 0) input.target.value = 0;
    if (input.target.value > 100) input.target.value = "100";
    return input;
};

export const textoExclusao = {
    title: "Atenção!",
    text: "Tem certeza que deseja remover esse registro?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    cancelButtonText: "Não",
    confirmButtonText: "Sim",
};

export const formatarDiaSemana = (dia) => {
    const dia_str = dia.replace("-feira", "");

    return dia_str.charAt(0).toUpperCase() + dia_str.slice(1);
};

export const formatNumerosPositivos = (input) => {
    const value = input.target.value;

    if ((!/^\d*$/.test(value) && value !== "") || isNaN(value) || value === "0") {
        input.target.value = 1;
    }

    return input;
};

export const formatBytesLabel = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";

    const k = 1000; // Base 10 para MB (MB != MiB)
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const isset = (value) => value !== null && value !== undefined;

export const formatarCelularComCodigoPais = (numero) => {
    const somenteNumeros = numero.replace(/\D/g, "");

    // Verifica se começa com código do Brasil (55)
    if (somenteNumeros.length >= 12 && somenteNumeros.startsWith("55")) {
        const ddd = somenteNumeros.slice(2, 4);
        const celular = somenteNumeros.slice(4);

        if (celular.length === 9) {
            const parte1 = celular.slice(0, 5);
            const parte2 = celular.slice(5);
            return `+55 (${ddd}) ${parte1}-${parte2}`;
        } else if (celular.length === 8) {
            const parte1 = celular.slice(0, 4);
            const parte2 = celular.slice(4);
            return `+55 (${ddd}) ${parte1}-${parte2}`;
        }
    }

    // Se não estiver no formato esperado, retorna como está
    return numero;
};

export const getCardFlag = (value) => {
    const card = value?.replace(/[^0-9]+/g, "");

    const cards = {
        elo: /^(4011|4312|4389|4514|4576|5041|5067|5090|6277|6362|6363|6504|6505|6507|6509|6516|6550|6551|6552)\d{12,15}$/,
        visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
        mastercard: /^5[1-5][0-9]{14}$/,
        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        hipercard: /^6062|3841/,
        jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
        amex: /^3[47][0-9]{13}$/,
        aura: /^50[0-9]{14}$/,
    };

    for (const flag in cards) {
        if (cards[flag].test(card)) {
            return flag;
        }
    }

    return false;
};

export const getBandeira = (value) => {
    if ("mastercard".includes(value?.toLowerCase())) {
        return <img src={"/icons/cardflag/mastercard.png"} style={{ width: 36, maxHeight: 25 }} alt="Cartão" />;
    } else if ("visa".includes(value?.toLowerCase())) {
        return <img src={"/icons/cardflag/visa.png"} style={{ width: 36, maxHeight: 25 }} alt="Cartão" />;
    } else if ("diners".includes(value?.toLowerCase())) {
        return <img src={"/icons/cardflag/diners.png"} style={{ width: 36, maxHeight: 25 }} alt="Cartão" />;
    } else if ("amex".includes(value?.toLowerCase())) {
        return <img src={"/icons/cardflag/amex.png"} style={{ width: 36, maxHeight: 25 }} alt="Cartão" />;
    } else if ("discover".includes(value?.toLowerCase())) {
        return <img src={"/icons/cardflag/discover.png"} style={{ width: 36, maxHeight: 25 }} alt="Cartão" />;
    } else if ("hiper".includes(value?.toLowerCase())) {
        return <img src={"/icons/cardflag/hipercard.png"} style={{ width: 36, maxHeight: 25 }} alt="Cartão" />;
    } else if ("elo".includes(value?.toLowerCase())) {
        return <img src={"/icons/cardflag/elo.png"} style={{ width: 36, maxHeight: 25 }} alt="Cartão" />;
    } else {
        return null;
    }
};

export const formatUltimosDigitosCartao = (bandeira, ultimos_digitos) => {
    if ("amex".includes(bandeira?.toLowerCase())) {
        return "**** ****** *" + ultimos_digitos;
    }

    return "**** ".repeat(3) + ultimos_digitos;
};

export const formatCVV = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");

    input.target.value = value;

    return input;
};

export const formatNumeroCartao = (input, cardFlag = null) => {
    const cleaned = input.target.value.replace(/[^0-9*]/g, "");
    const cardType = cardFlag ?? getCardFlag(cleaned);

    // Aplica a máscara conforme o tipo
    switch (cardType) {
        case "amex": // 15 dígitos: #### ###### #####
            input.target.value = cleaned.replace(/^([\d\*]{0,4})([\d\*]{0,6})([\d\*]{0,5})/, "$1 $2 $3").trim();
            break;
        case "diners": // 14 dígitos: #### ###### ####
            input.target.value = cleaned.replace(/^([\d\*]{0,4})([\d\*]{0,6})([\d\*]{0,4})/, "$1 $2 $3").trim();
            break;
        case "elo":
        case "hipercard":
        case "visa":
        case "mastercard":
        case "discover":
        case "jcb":
        default:
            // Até 19 dígitos, formatado em blocos de 4
            input.target.value = cleaned.replace(/(.{1,4})/g, "$1 ").trim();
            break;
    }

    return input;
};

export const JSONCompare = (obj1, obj2) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
};

const conteudoAssinaturaCiclo = ["Automatização inteligente dos registros financeiros por texto", "Organização centralizada de receitas, despesas, cartões e contas bancárias em um só lugar", "Alertas personalizados para lembretes de gastos e vencimentos", "Relatórios claros e visuais, com gráficos que facilitam a tomada de decisão", "Mais controle e previsibilidade, garantindo uma gestão financeira prática e segura"];

export const listaAssinaturaCiclo = [
    { value: "YEARLY", label: "Anual", cor: "#0A7C08", nome: "Assinatura Anual", valor: 358.8, conteudos: conteudoAssinaturaCiclo, periodo: "por ano", periodoMin: "ano" },
    { value: "MONTHLY", label: "Mensal", cor: "#0D9F0A", nome: "Assinatura Mensal", valor: 39.9, conteudos: conteudoAssinaturaCiclo, periodo: "por mês", periodoMin: "mês" },
];

export const getIniciais = (nome) => {
    if (!nome) {
        return "";
    }

    const arrayNome = nome?.split(" ");
    const name = arrayNome?.length > 1 ? `${arrayNome[0][0]}${arrayNome[1][0]}` : arrayNome[0][0];

    return name?.toUpperCase();
};

export const getNomeSobrenome = (nome) => {
    if (!nome) {
        return "";
    }

    const arrayNome = nome?.split(" ");

    return arrayNome?.length > 1 ? `${arrayNome[0]} ${arrayNome[arrayNome.length - 1]}` : arrayNome[0];
};

export const listaHumorAssistente = [
    { value: "HUMORADO", label: "Humorado" },
    { value: "FORMAL", label: "Formal" },
    { value: "MODERADO", label: "Moderado" },
];

export const listaMotivoCancelamento = [
    { value: "Custo do plano", label: "Custo do plano" },
    { value: "Pouco uso da plataforma", label: "Pouco uso da plataforma" },
    { value: "Funcionalidades limitadas", label: "Funcionalidades limitadas" },
    { value: "Dificuldade de uso", label: "Dificuldade de uso" },
    { value: "Não atendeu às expectativas", label: "Não atendeu às expectativas" },
    { value: "Suporte/Atendimento ruim", label: "Suporte/Atendimento ruim" },
    { value: "Necessidades mudaram", label: "Necessidades mudaram" },
    { value: "Outro", label: "Outro" },
];

export const listaTamanhoRespostaAssistente = [
    { value: "CURTA", label: "Curta" },
    { value: "MEDIA", label: "Média" },
    { value: "LONGA", label: "Longa" },
];

export const listaLembreteFaturaCartaoCredito = [
    { value: "5_DIAS_ANTES", label: "5 dias antes" },
    { value: "NO_DIA", label: "No dia" },
    { value: "APOS_VENCIMENTO", label: "Após o vencimento" },
];

export const listaLembretePorcentagemCartaoDisponivel = [
    { value: 50, label: "50%" },
    { value: 25, label: "25%" },
    { value: 10, label: "10%" },
    { value: 0, label: "0%" },
];

export const listaLembreteSaldoContaDisponivel = [
    { value: 50, label: "50%" },
    { value: 25, label: "25%" },
    { value: 10, label: "10%" },
    { value: 0, label: "0%" },
];

export const listaLembretePagamentosRecorrentes = [
    { value: "5_DIAS_ANTES", label: "5 dias antes" },
    { value: "NO_DIA", label: "No dia" },
    { value: "APOS_VENCIMENTO", label: "Após o vencimento" },
];

export const listaLembreteRegistrarDespesas = [
    { value: "DIARIO", label: "Diário" },
    { value: "SEMANAL", label: "Semanal" },
    { value: "MENSAL", label: "Mensal" },
];

export const listaLembreteResumoDespesas = [
    { value: "DIARIO", label: "Diário" },
    { value: "SEMANAL", label: "Semanal" },
    { value: "MENSAL", label: "Mensal" },
];

export const listaLembreteInsightsInteligentes = [
    { value: "DIARIO", label: "Diário" },
    { value: "SEMANAL", label: "Semanal" },
    { value: "A_CADA_15_DIAS", label: "A cada 15 dias" },
    { value: "MENSAL", label: "Mensal" },
];

export const listaPeriodicidadeTransacao = [
    { value: "DIARIA", label: "Diário" },
    { value: "SEMANAL", label: "Semanal" },
    { value: "MENSAL", label: "Mensal" },
    { value: "TRIMESTRAL", label: "Trimestral" },
    { value: "ANUAL", label: "Anual" },
    { value: "PERSONALIZADO", label: "Personalizado" },
];

export const listaRecorrencia = [
    { label: "Não recorrente", value: "NAO_RECORRENTE" },
    { label: "Parcelar ou repetir", value: "PARCELADA" },
    { label: "Fixa mensal", value: "FIXA" },
];

export const listaTipoTransacao = [
    { label: "Despesa", value: "DESPESA" },
    { label: "Receita", value: "RECEITA" },
];

export const primeiraMaiuscula = (texto = null) => {
    if (!texto) {
        return "";
    }

    return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
};

export const statusPagamentoCompleto = (status) => {
    if (["CONFIRMED", "RECEIVED", "RECEIVED_IN_CASH"].includes(status)) {
        return { label: "Pago", cor: "#2E7D32", background: "#2E7D321A" };
    } else if (status === "OVERDUE") {
        return { label: "Vencido", cor: "#C62828", background: "#C628281A" };
    }

    return { label: "Pendente", cor: "#EF6C00", background: "#EF6C001A" };
};

export const hexToRgba = (hex, opacity) => {
    hex = hex.replace("#", "");

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const chaveAleatoria = () => {
    return Math.random()
        .toString(36)
        .substring(2);
};

export const listaIcones = [
    { name: "categoria-1.svg", path: "/icons/categorias/categoria-1.svg" },
    { name: "categoria-2.svg", path: "/icons/categorias/categoria-2.svg" },
    { name: "categoria-3.svg", path: "/icons/categorias/categoria-3.svg" },
    { name: "categoria-4.svg", path: "/icons/categorias/categoria-4.svg" },
    { name: "categoria-5.svg", path: "/icons/categorias/categoria-5.svg" },
    { name: "categoria-6.svg", path: "/icons/categorias/categoria-6.svg" },
    { name: "categoria-7.svg", path: "/icons/categorias/categoria-7.svg" },
    { name: "categoria-8.svg", path: "/icons/categorias/categoria-8.svg" },
    { name: "categoria-9.svg", path: "/icons/categorias/categoria-9.svg" },
    { name: "categoria-10.svg", path: "/icons/categorias/categoria-10.svg" },
    { name: "categoria-11.svg", path: "/icons/categorias/categoria-11.svg" },
    { name: "categoria-12.svg", path: "/icons/categorias/categoria-12.svg" },
    { name: "categoria-13.svg", path: "/icons/categorias/categoria-13.svg" },
    { name: "categoria-14.svg", path: "/icons/categorias/categoria-14.svg" },
    { name: "categoria-15.svg", path: "/icons/categorias/categoria-15.svg" },
    { name: "categoria-16.svg", path: "/icons/categorias/categoria-16.svg" },
    { name: "categoria-17.svg", path: "/icons/categorias/categoria-17.svg" },
    { name: "categoria-18.svg", path: "/icons/categorias/categoria-18.svg" },
    { name: "categoria-19.svg", path: "/icons/categorias/categoria-19.svg" },
    { name: "categoria-20.svg", path: "/icons/categorias/categoria-20.svg" },
    { name: "categoria-21.svg", path: "/icons/categorias/categoria-21.svg" },
    { name: "categoria-22.svg", path: "/icons/categorias/categoria-22.svg" },
    { name: "categoria-23.svg", path: "/icons/categorias/categoria-23.svg" },
    { name: "categoria-24.svg", path: "/icons/categorias/categoria-24.svg" },
    { name: "categoria-25.svg", path: "/icons/categorias/categoria-25.svg" },
    { name: "categoria-26.svg", path: "/icons/categorias/categoria-26.svg" },
    { name: "categoria-27.svg", path: "/icons/categorias/categoria-27.svg" },
    { name: "categoria-28.svg", path: "/icons/categorias/categoria-28.svg" },
    { name: "categoria-29.svg", path: "/icons/categorias/categoria-29.svg" },
    { name: "categoria-30.svg", path: "/icons/categorias/categoria-30.svg" },
    { name: "categoria-31.svg", path: "/icons/categorias/categoria-31.svg" },
    { name: "categoria-32.svg", path: "/icons/categorias/categoria-32.svg" },
    { name: "categoria-33.svg", path: "/icons/categorias/categoria-33.svg" },
    { name: "categoria-34.svg", path: "/icons/categorias/categoria-34.svg" },
    { name: "categoria-35.svg", path: "/icons/categorias/categoria-35.svg" },
    { name: "categoria-36.svg", path: "/icons/categorias/categoria-36.svg" },
    { name: "categoria-37.svg", path: "/icons/categorias/categoria-37.svg" },
    { name: "categoria-38.svg", path: "/icons/categorias/categoria-38.svg" },
    { name: "categoria-39.svg", path: "/icons/categorias/categoria-39.svg" },
    { name: "categoria-40.svg", path: "/icons/categorias/categoria-40.svg" },
    { name: "categoria-41.svg", path: "/icons/categorias/categoria-41.svg" },
    { name: "categoria-42.svg", path: "/icons/categorias/categoria-42.svg" },
];

export const listaStatusTransacao = [
    { value: "A_PAGAR", label: "A Pagar", color: "#EF6C00" },
    { value: "A_RECEBER", label: "A Receber", color: "#EF6C00" },
    { value: "PAGO", label: "Pago", color: "#2E7D32" },
    { value: "RECEBIDO", label: "Recebido", color: "#2E7D32" },
];

export const tipoStatusTransacao = (status, tipo) => {
    if (status === "EFETIVADA" && tipo === "DESPESA") {
        return "PAGO";
    } else if (status === "EFETIVADA" && tipo === "RECEITA") {
        return "RECEBIDO";
    } else if (status === "PENDENTE" && tipo === "DESPESA") {
        return "A_PAGAR";
    } else if (status === "PENDENTE" && tipo === "RECEITA") {
        return "A_RECEBER";
    }

    return null;
};

export const tipoTransacaoStatus = (status) => {
    if (status === "PAGO") {
        return { tipo: "DESPESA", status: "EFETIVADA" };
    } else if (status === "RECEBIDO") {
        return { tipo: "RECEITA", status: "EFETIVADA" };
    } else if (status === "A_PAGAR") {
        return { tipo: "DESPESA", status: "PENDENTE" };
    } else if (status === "A_RECEBER") {
        return { tipo: "RECEITA", status: "PENDENTE" };
    }

    return null;
};

export const gerarCorHexadecimal = () => {
    const letras = "0123456789ABCDEF";
    let cor = "#";

    for (let i = 0; i < 6; i++) {
        cor += letras[Math.floor(Math.random() * 16)];
    }

    return cor;
};

export const listaMesesVencimentoAno = (primeiroVencimento = null) => {
    if (!primeiroVencimento) {
        primeiroVencimento = moment()
            .startOf("month")
            .toDate();
    }

    let base = moment(primeiroVencimento);
    const fim = moment()
        .add(1, "years")
        .endOf("month");

    const meses = [];

    while (base.isSameOrBefore(fim, "month")) {
        const anoAtual = base.year();
        const mesAtual = base.month();

        const mes = (mesAtual + 1).toString().padStart(2, "0");

        meses.push({
            value: `${anoAtual}-${mes}-01`,
            label: moment(`${anoAtual}-${mes}-01`).format("MMMM/YYYY"),
        });

        base = base.add(1, "month");
    }

    return meses;
};

export const dataValida = (momentDate, dia) => {
    let data = momentDate.clone().date(dia);

    if (momentDate.month() !== data.month()) {
        data = momentDate.endOf("month");
    }

    return data;
};

export const listaDiasSemana = [
    { value: 7, label: "Domingo" },
    { value: 1, label: "Segunda-feira" },
    { value: 2, label: "Terça-feira" },
    { value: 3, label: "Quarta-feira" },
    { value: 4, label: "Quinta-feira" },
    { value: 5, label: "Sexta-feira" },
    { value: 6, label: "Sábado" },
];
